
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';
import { DropdownSearchComponent } from './dropdown-search.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    declarations: [
        DropdownSearchComponent,
    ],
    exports: [
        DropdownSearchComponent
    ],
})

export class DropdownSearchModule { }
